import { Container } from "@material-ui/core";
import React, { Component } from "react";
import {
    ConfidenceButtons,
    DeckCard,
    HomeDeckCard,
    QuestionCard,
    Header,
    TestTableCard,
    Footer
} from "../components";
import { SkeletonImage } from "../components/SkeletonImage";
import { Images } from "../images";
import { testQuestion } from "../testQuestion";

//TODO organize components

class TestScreen extends Component {
    state = {
        oneSelected: false,
        twoSelected: false
    };

    render() {
        return (
            <Container>
                <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <QuestionCard
                        answers={testQuestion[0].qoptions}
                        question={testQuestion[0]}
                    />
                </div>
                <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <DeckCard deckColor="neutralGreenCard" textColor="neutralGreenText" />
                </div>
                <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <HomeDeckCard
                        textColor="neutralGreenText"
                        deckColor="neutralGreenCard"
                        buttonColor="neutralGreen"
                        index={0}
                        totalLength={0}
                    />
                </div>
                <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <TestTableCard />
                </div>
            </Container>
        );
    }
}

export { TestScreen };
